var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import { createPngImage, } from "../utilities/aux";
let ReadOnlyPartRow = class ReadOnlyPartRow extends Vue {
    deletionClicked() { }
    updateSvg() {
        if (this.showSvg) {
            const s = this.$el.querySelector(".svgPicture");
            if (s === undefined || s === null) {
                throw Error("Selector '.svgPicture' does not match");
            }
            if (s.contains(this.svg)) {
                s.removeChild(this.svg);
            }
            this.svg = (new DOMParser())
                .parseFromString(this.rowData.svg, "image/svg+xml").documentElement;
            s.appendChild(this.svg);
        }
    }
    get showThickness() { return !this.deleted && this.displayInfo.thickness !== "-"; }
    get cssClass() {
        const css = {};
        css["deleted"] = this.deleted;
        return css;
    }
    get showPng() { return !this.deleted && this.rowData.png !== undefined; }
    get showSvg() { return !this.deleted && !this.showPng && this.rowData.svg !== undefined; }
    get partState() {
        if (this.displayInfo.partState === undefined) {
            throw Error("Wrong type.");
        }
        return this.displayInfo.partState;
    }
    get rowData() {
        return {
            png: this.displayInfo.png !== undefined ? createPngImage(this.displayInfo.png) : undefined,
            svg: this.displayInfo.svg,
            articleName: this.displayInfo.articleName,
            thickness: this.displayInfo.thickness,
            deleted: this.deleted,
            status: this.partState,
        };
    }
    mounted() {
        if (!this.deleted) {
            if (!this.showPng && !this.showSvg) {
                throw Error("At least one picture for the thumbnail has to exist");
            }
        }
        this.updateSvg();
    }
    updated() { this.updateSvg(); }
};
__decorate([
    Prop({ required: true })
], ReadOnlyPartRow.prototype, "deleted", void 0);
__decorate([
    Prop({ required: true })
], ReadOnlyPartRow.prototype, "displayInfo", void 0);
__decorate([
    Inject()
], ReadOnlyPartRow.prototype, "i18n", void 0);
__decorate([
    Emit()
], ReadOnlyPartRow.prototype, "deletionClicked", null);
ReadOnlyPartRow = __decorate([
    Component({
        components: {},
        name: "ReadOnlyPartRow",
    })
], ReadOnlyPartRow);
export default ReadOnlyPartRow;
